import groupNews from '../../components/groupNews/groupNews'
import industryDynamics from '../../components/industryDynamics/industryDynamics'
export default ({
    data() {
        return {
            currentMenu: '/news/groupNews',
        }
    },
    components: { groupNews, industryDynamics },
    created() {
        var route = this.$route.path
        this.currentMenu = route
    },
    watch:{
        //监听路由变化
        $route(to,from){
            var route = to.path
            this.currentMenu = route
        }
    },
    methods: {
        selectMenu(page){
            this.currentMenu = page
            var route = this.$route.path
            if(page != route){
                this.$router.push({path: page})
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/pages/news/news.vue.js